import Navigation from "@/components/navigation/Navigation.vue";

export default {
  components: {
    Navigation,
  },
  name: "Header",

  data: () => ({
    drawer: false,
    user: [],
  }),

  async beforeMount() {
    this.user = this.$store.state.user
  },

  computed: {
    fullName() {
      const name = this.$store.state.user.name;
      if (!name) return '';
      const names = name.split(' ');
      return `${names[0]} ${names[names.length - 1]}`;
    },
    initials() {
      const name = this.$store.state.user.name;
      if (!name) return '';
      const names = name.split(' ');
      const firstInitial = names[0].charAt(0);
      const lastInitial = names[names.length - 1].charAt(0);
      return `${firstInitial}${lastInitial}`;
    }
  },

  methods: {
    logout() {
      this.$keycloak.logout();
    },

    goTo() {
      this.$router.push("/");
    }
  }
};